import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "gatsby";
import loadingGif from "../images/loading.gif";
import { getTokenIdsByCollection } from '../api/api';
import close_modal from "../images/close_modal.svg";
import Modal from 'react-modal';

const ShowNewClaimedNfts: React.FC = (props) => {

    const [claimedNftsCount, setClaimedNftsCount] = useState(0);
    const [claimedNfts, setClaimedNfts] = useState<string[]>([]);
    const [showGallery, setShowGallery] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [selectedLink, setSelectedLink] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const { collectionOwner, collectionImageUrl, collectionName, collectionUrl } = props;

    const callGetClaimedNfts = async () => {
        setShowGallery(true);
        setIsLoading(true);
        try {
            console.log('Fetching collection tokens for owner:', collectionOwner);
            const collectionTokens = await getTokenIdsByCollection(collectionOwner);
            console.log('API response:', collectionTokens);
            console.log('Response type:', typeof collectionTokens);
            console.log('Response length:', collectionTokens?.length);
            
            if (collectionTokens && Array.isArray(collectionTokens)) {
                setClaimedNftsCount(collectionTokens.length);
                const sortedTokens = collectionTokens.sort((a, b) => parseInt(a) - parseInt(b));
                setClaimedNfts(sortedTokens);
                console.log('Set claimed NFTs:', sortedTokens);
            } else {
                console.error('Invalid response format:', collectionTokens);
                setClaimedNfts([]);
                setClaimedNftsCount(0);
            }
        } catch (error) {
            console.error('Error fetching collection tokens:', error);
            setClaimedNfts([]);
            setClaimedNftsCount(0);
        } finally {
            setIsLoading(false);
        }
    };

    /* MODAL */
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: '35px',
            transform: 'translate(-50%, -50%)',
            background: '#FFFFFF',
            zIndex: '999',
            maxWidth: '90%',
            maxHeight: '90%',
            overflow: 'auto'
        },
        overlay: {
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
        }
    };

    Modal.setAppElement('#___gatsby');

    const openModal = (image, title, url) => {
        setSelectedImage(image);
        setSelectedTitle(title);
        setSelectedLink(url);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setSelectedImage(null);
        setSelectedTitle('');
        setSelectedLink('');
        setModalIsOpen(false);
    };

    useEffect(() => {
        callGetClaimedNfts();
    }, []);

    const PaginatedGallery = ({ data, RenderComponent, pageLimit, dataLimit }) => {
        const pages = Math.ceil(data.length / dataLimit);
        const changePage = (event) => {
            const pageNumber = Number(event.target.textContent);
            //console.log("Changing to page:", pageNumber);
            setCurrentPage(pageNumber);
            // const filterSection = document.getElementById('filters');
            // filterSection.scrollIntoView({ behavior: 'smooth' });
        };

        const getPaginatedData = useCallback(() => {
            const startIndex = currentPage * dataLimit - dataLimit;
            const endIndex = startIndex + dataLimit;
            return data.slice(startIndex, endIndex);
        }, [currentPage, data, dataLimit]);

        const getPaginationGroup = useCallback(() => {
            let start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
            return new Array(pageLimit).fill().map((_, idx) => start + idx + 1).filter(page => page <= pages);
        }, [currentPage, pageLimit, pages]);

        return (
            <>
                <p>&nbsp;</p>
                <div className='clearfix' id='filters'></div>
                <div>
                    <div className='collections-list'>
                        {getPaginatedData().map((d, idx) => (
                            <RenderComponent key={idx} data={d} />
                        ))}
                    </div>
                    <div className='pagination'>
                        {getPaginationGroup().map((item, index) => (
                            <div className={`button ${currentPage === item ? "black" : ""}`}
                                key={index}
                                onClick={changePage}
                            >
                                <span>{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        );
    };

    const IndividualPopulus = ({ data }) => {
        const picUrl = useMemo(() => collectionImageUrl.replace("#token_id", data).replace("1200/800", "1000/600"), [data, collectionImageUrl]);
        const mobilePicUrl = useMemo(() => collectionImageUrl.replace("#token_id", data).replace("1200/800", "800/400"), [data, collectionImageUrl]);
        const imageTitle = useMemo(() => (props.collectionListNames) ? props.collectionListNames[data] : `${collectionName} #${data}`, [data, props.collectionListNames, collectionName]);
        const liveUrl = useMemo(() => `${collectionUrl}${data}?title=${encodeURIComponent(imageTitle)}`, [data, collectionUrl, imageTitle]);

        const handleModalOpen = (e) => {
            e.preventDefault();
            //console.log("Modal open clicked:", { picUrl, imageTitle, liveUrl });
            openModal(picUrl, imageTitle, liveUrl);
        };

        return (
            <div className='col30 left collection-item populus'>
                <a className='image' onClick={handleModalOpen}
                    style={{ backgroundImage: `url(${mobilePicUrl})` }}></a>
                <div className='details'>
                    <h4 style={{ textTransform: `capitalize` }}>{imageTitle}</h4>
                    <Link className='button black detailed-view' to={liveUrl} onClick={handleModalOpen}>View</Link>
                </div>
            </div>
        );
    };

    return (
        <>
            <section className='collection-detail'>
                <div className='container clearfix'>
                    {showGallery ? (
                        claimedNfts.length > 0 ? (
                            <PaginatedGallery
                                data={claimedNfts}
                                RenderComponent={IndividualPopulus}
                                pageLimit={10}
                                dataLimit={48}
                            />
                        ) : (
                            isLoading ? (
                                <><img alt="Loading" className="loading" src={loadingGif} /></>
                            ) : (
                                <></>
                            )
                        )
                    ) : (
                        <><a className='button arrow transparent' onClick={callGetClaimedNfts}>Show Already Minted Pieces</a></>
                    )}
                </div>
            </section>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                portalClassName="minting-modal"
                contentLabel="View Image"
            >
                <div id="minting">
                    <a className='close-modal' onClick={closeModal}><img src={close_modal} /></a>
                    <div className="minting-step-info">
                        {selectedImage && (
                            <img src={selectedImage} alt="Selected" style={{ width: '100%', height: 'auto', maxWidth: '100%', maxHeight: '80vh' }} />
                        )}
                        <h4 className="text-center" style={{ textTransform: `capitalize` }}>{selectedTitle}</h4>
                        <a className='button black detailed-view close' href={selectedLink}>View</a>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ShowNewClaimedNfts;
